import { Target } from '../@types';

const targetsForFuelTransactions: Target[] = [
  { value: 'uniqueId', type: 'text', isAPI: true, queryName: 'externalId' },
  { value: 'type', type: 'selection', isAPI: true, queryName: 'type' },
  {
    value: 'flagged',
    type: 'boolean',
    isAPI: true,
    allowUnknown: false,
    allowFalse: false,
  },
  {
    value: 'timestamp',
    type: 'date',
    isAPI: true,
    queryNameFrom: 'dateFrom',
    queryNameTo: 'dateTo',
  },
  {
    value: 'fuelStationBrandName',
    type: 'text',
    isAPI: true,
    queryName: 'fuelStationBrand',
  },
  { value: 'product', type: 'text', isAPI: true, queryName: 'product' },
  { value: 'plate', type: 'text', isAPI: true, queryName: 'carPlate' },
  { value: 'carId', type: 'text', isAPI: true, queryName: 'carId' },
  { value: 'code', type: 'text', isAPI: true, queryName: 'tripCode' },
  { value: 'tripId', type: 'text', isAPI: true, queryName: 'tripId' },
  {
    value: 'userReferralCode',
    type: 'text',
    isAPI: true,
    queryName: 'userReferralCode',
  },
  { value: 'userId', type: 'text', isAPI: true, queryName: 'userId' },
  {
    value: 'brandName',
    type: 'text',
    isAPI: true,
    queryName: 'brands',
    queryType: 'array',
  },
  {
    value: 'merchantName',
    type: 'text',
    isAPI: true,
    queryName: 'merchantName',
  },
  {
    value: 'fleetId',
    type: 'selection',
    isAPI: true,
    queryName: 'fleets',
    queryType: 'array',
  },
  {
    value: 'quantity',
    type: 'number',
    isAPI: true,
    queryNameFrom: 'quantityFrom',
    queryNameTo: 'quantityTo',
  },
  {
    value: 'amountTotal',
    type: 'number',
    isAPI: true,
    queryNameFrom: 'amountFrom',
    queryNameTo: 'amountTo',
  },
];

export default targetsForFuelTransactions;
